import { render, staticRenderFns } from "./TabBerkasLampiran.vue?vue&type=template&id=f56a5798&scoped=true"
import script from "./TabBerkasLampiran.vue?vue&type=script&lang=js"
export * from "./TabBerkasLampiran.vue?vue&type=script&lang=js"
import style0 from "./TabBerkasLampiran.vue?vue&type=style&index=0&id=f56a5798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56a5798",
  null
  
)

export default component.exports